import csi from "csi/main";
import config from "csi/config";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";
import _ from "lodash";
import MultiActionPopupMixin from "csi/action/MultiActionPopupMixin";
import NewFormulatedProductAddProductHierarchy from "./NewFormulatedProductAddProductHierarchy";

const PRODUCT_HIERARCHY = "ProductHierarchy";
const PRODUCT_HIERARCHY_DETAILS = "ProductHierarchyDetails";
const PRODUCT_HIERARCHY_FOLDER = "ProductHierarchyFolder";

const NewFormulatedProductMultiAddProductHierarchy = declare([NewFormulatedProductAddProductHierarchy, MultiActionPopupMixin], {
	// Dialog localization strings
	loadingMessageTemplateSingular: "MassCreateFood_LoadingSingular",
	loadingMessageTemplatePlural: "MassCreateFood_LoadingPlural",
	successMessageTemplateSingular: "MassCreateFood_SuccessSingular",
	successMessageTemplatePlural: "MassCreateFood_SuccessPlural",

	// String: name of field containing number of nodes to create
	numCreateField: "NumToCreate",

	forceReturnNodes: true,
	/** @property {C8Node[]} _newlyCreatedFoods -  List of newly created foods */
	_newlyCreatedFoods: null,

	/** 
	 * @override
	 * Get newly created foods/ formulated materials
	 */
	onPublishResponse(response) {
		const ctx = this.getContext();
		const view = ctx?.defView;
		if (this._newlyCreatedFoods == null) {
			if (view?.m_id === "FormulatedMaterials") {
				this._newlyCreatedFoods = response.getNodesOfType("FormulatedMaterial");
			} else { // Food
				this._newlyCreatedFoods = response.getNodesOfType("Food");
			}
		}
	},

	/** 
	 * @override 
	 *  Return newly created Foods to support New Foods operation default table behavior
	 */
	getNewNodes() {
		if (this._newlyCreatedFoods == null) {
			return [];
		}
		const sortedNodes = csi.sort(this._newlyCreatedFoods, "$URL");
		this._newlyCreatedFoods = null;
		return sortedNodes;
	},

	/**
	 * @override
	 * Override to not add the save and go button to prevent flickering
	 * @returns boolean describing 
	 */
	_canNavigate: function () {
		const ctx = this.getContext();
		const cache = this.m_cache;
		const node = ctx.getParent();
		const view = ctx?.defView;

		// if the form is a formulated product in a top level hierarchy or a folder return true
		if (view?.m_id === "FormulatedMaterials" && (node.$Type === PRODUCT_HIERARCHY || node.$Type === PRODUCT_HIERARCHY_FOLDER)){
			return true;
		}

		let hierarchyURL;
		if (node) {
			switch (node.$Type) {
				case PRODUCT_HIERARCHY_DETAILS:
					hierarchyURL = node.ProductHierarchy;
					break;
				case PRODUCT_HIERARCHY:
					hierarchyURL = node.$URL;
					break;
				case PRODUCT_HIERARCHY_FOLDER:
					hierarchyURL = node.HierarchyParents.first();
					break;
			}
		}

		const subtypeUrl: string = cache?.getNode(hierarchyURL)?.Subtype;
		const massCreateProductLimit: number = config.getSubtypeSetting(subtypeUrl, "MassCreateProductLimit") as unknown as number;

		return this.inherited<boolean>(arguments) && (!massCreateProductLimit || massCreateProductLimit === 1);
	},

	toWriterRequest() {
		const call = this.inherited<CallMethod>(arguments);

		const fd = this.m_formData;

		// C8FB-1405: Add custom configured fields to the call to NewFoods operation so that each new Food
		// has the same required and custom configured attributes.
		_.forEach(fd.getFields(), (field) => {
			const fieldId = field.idParameter || field.m_id;
			if (fieldId && !field.m_bUsed) {
				call.addGeneralizedParameter(fieldId, field.getType(), field.getValue());
				field.m_bUsed = true;
			}
		});
		
		return call;
	},

});

export = NewFormulatedProductMultiAddProductHierarchy;
